import React, {useState} from 'react'
import useDidMountEffect from '../../../../../hooks/useDidMountEffect/useDidMountEffect'
import {Div} from "../../../../registroMaternidad/modales/components/Components";
import InputSelect from "../../../../../components/modalComponents/InputSelect";
import InputText from "../../../../../components/modalComponents/InputText";
import InputUploadFile from "../../../../../components/modalComponents/InputUploadFile";
import {FirmaConvenioBeneficiosSteps} from "../components/StyledComponents";
import {useManagePostRequest} from "../../../../../hooks/useManagePostRequest/useManagePostRequest";
import {
    crearSolicitudBeneficioAPI,
    generarDocumentoCartaAutorizacionBeneficioAPI,
} from "../../../../../consumers/backendApisUrls";
import {
    useGenerarDescargarEliminarArchivo
} from "../../../../../hooks/useGenerarDescargarEliminarArchivo/useGenerarDescargarEliminarArchivo";

const SolicitarBeneficios = ({
                                 sendCurrentStep,
                                 setSendCurrentStep,
                                 componentStep,
                                 KEYS,
                                 selectProps,
                                 SECTION_NAME,
                                 formValues,
                                 modalData,
                                 setModalData,
                                 getPayloadToSubmitItems,
                                 setFormValues,
                                 setDisableSubmitButton,
                                 toggleModal,
                                 refreshPage
                             }) => {

    const [executeManagePost] = useManagePostRequest();
    const [descargandoArchivo, setDescargandoArchivo] = useState(false);
    const [generarYDescargarArchivo] = useGenerarDescargarEliminarArchivo();

    useDidMountEffect(() => {
        if (sendCurrentStep?.step === componentStep && sendCurrentStep?.isSent) {
            handleSubmit();
        }
    }, [sendCurrentStep])

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        setDisableSubmitButton(true);
        let payload = getPayloadToSubmitItems();
        payload = {
            ...payload,
            [KEYS.cartaAutorizacionBeneficioFileViewModel]: formValues[KEYS.cartaAutorizacionBeneficioFileViewModel]            
        }

        if (modalData?.campanaBeneficioItemsToSolicitarResponse?.RequiereDataExterna) {
            payload = {
                ...payload,
                IdAlumnoMatriculado: formValues.IdAlumnoMatriculado || null,
                NombreAlumnoMatriculado: formValues.NombreAlumnoMatriculado || '',
                DniAlumnoMatriculado: formValues.DniAlumnoMatriculado || ''  ,
                IndicaAlumnoMatriculado: formValues.IndicaAlumnoMatriculado || false
            };
        }

        const api = crearSolicitudBeneficioAPI();
        await executeManagePost(api, payload, ({data}) => handleCrearSolicitudBeneficioCallback(data), true, null, true);
        setDisableSubmitButton(false);
    }

    const handleCrearSolicitudBeneficioCallback = (responseData) => {
        toggleModal();
        refreshPage();
    }

    const descargarCartaCompromiso = async (e) => {
        e.preventDefault();
        setDescargandoArchivo(true);
        const payload = {
            [KEYS.idCampanaBeneficio]: formValues[KEYS.idCampanaBeneficio],
            "Monto": modalData?.currentTotal,
            [KEYS.CuotasPago]: formValues[KEYS.CuotasPago]
        }
        await generarYDescargarArchivo(generarDocumentoCartaAutorizacionBeneficioAPI(), payload);
        setDescargandoArchivo(false);
    }

    return (
        <div>
            <div className="displayFlexWrap">
                <Div>
                    <InputSelect
                        label="Campaña"
                        {...selectProps(KEYS.idCampanaBeneficio)}
                        sectionName={SECTION_NAME}
                        isDisabled={true}
                        isRequired={true}
                    />
                </Div>
                {modalData?.initialDataResponse?.FechaActual &&
                    <Div>
                        <InputText
                            name="Fecha"
                            label="Fecha"
                            value={modalData?.initialDataResponse?.FechaActual}
                            placeholder=""
                            isDisabled
                        />

                    </Div>
                }

                {modalData?.initialDataResponse?.NombreEmpleado &&
                    <Div>
                        <InputText
                            name="NombreEmpleado"
                            label="Empleado"
                            value={modalData?.initialDataResponse?.NombreEmpleado}
                            placeholder=""
                            isDisabled
                        />
                    </Div>
                }

                {modalData?.initialDataResponse?.Sede &&
                    <Div>
                        <InputText
                            name="Sede"
                            label="Sede"
                            value={modalData?.initialDataResponse?.Sede}
                            placeholder=""
                            isDisabled
                        />
                    </Div>
                }

                {modalData?.campanaBeneficioItemsToSolicitarResponse?.CuotasMax &&
                    <Div>
                        <InputSelect
                            label="Cuotas"
                            {...selectProps(KEYS.CuotasPago)}
                            name="CuotasPago"
                            isRequired={true}
                            isDisabled
                        />
                    </Div>
                }

                {modalData?.campanaBeneficioItemsToSolicitarResponse?.RequiereDataExterna && (
                    <Div>
                        <InputText
                            label="Alumno matriculado"
                            value={formValues.NombreAlumnoMatriculado}
                            placeholder=""
                            isDisabled={true}
                            isRequired={true}
                        />

                    </Div>
                )}

                {modalData?.campanaBeneficioItemsToSolicitarResponse?.SolicitarNumeroWhatsApp && (
                    <Div>
                        <InputText
                            name={KEYS.NumeroWhatsApp}
                            label="Número de WhatsApp"
                            value={formValues[KEYS.NumeroWhatsApp] ?? ''}
                            placeholder=""
                            isDisabled={true}
                            isRequired={true}
                        />
                    </Div>
                )}

            </div>


            <div>
                <p style={{fontWeight: 600}}>Firma de Autorización de Descuento por Planilla</p>
            </div>

            <FirmaConvenioBeneficiosSteps className="d-flex align-items-center justify-content-center">
                <div className="column-step1 ">
                    <div className="step-number">1</div>
                    <div className="button">
                        <button className="btn btn-primary generic-button-ficha" disabled={descargandoArchivo}
                                onClick={(e) => {
                                    descargarCartaCompromiso(e)
                                }}> {descargandoArchivo ? 'Descargando...' : 'Descargar'}
                        </button>
                    </div>
                </div>
                <div className="column-step2">
                    <div className="step-number">2</div>
                    <InputUploadFile
                        name={KEYS.cartaAutorizacionBeneficioFileViewModel}
                        uploadFile={formValues[KEYS.cartaAutorizacionBeneficioFileViewModel]}
                        setUploadFile={(res) =>
                            setFormValues({...formValues, [KEYS.cartaAutorizacionBeneficioFileViewModel]: res})
                        }
                        sectionName={SECTION_NAME}
                        setIsUploading={setDisableSubmitButton}
                        validExtensions={["pdf"]}
                        isRequired={true}
                        colLabel={0}
                        colInput={12}
                    />
                </div>
            </FirmaConvenioBeneficiosSteps>


        </div>
    )
}

export default SolicitarBeneficios;